import {Plus} from "lucide-react";
import {Button} from "@/components/ui/button";

type Props = {
  onClick: () => void;
  label?: string;
  disabled?: boolean;
};

export function AdminAddButton({onClick, label = "Add", disabled}: Props) {
  return (
    <Button type="button" size="sm" className="gap-2 shadow-sm" onClick={onClick} disabled={disabled}>
      <Plus className="h-4 w-4" />
      {label}
    </Button>
  );
}
